/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Constants, formatAmount } from '../../../utils';
import { Input, Select } from '../../../components';
import { BillingService, GeneralService } from '../../../services';

const ModalPay = ({ destiny, data, onClose, onSuccess }) => {
  const { form, isLoading, onChange, onSubmit, selects } = useForm(destiny, data, onClose, onSuccess);

  return (
    <div className="w-[30rem] mx-auto bg-white p-6 rounded-2xl font-sans antialiased selection:bg-orange-100 relative">
      <button
        type="button"
        className="p-1.5 rounded-full hover:bg-gray5 transition-colors absolute top-2 right-2"
        onClick={onClose}
        disabled={isLoading}
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>

      <div className="mb-4">
        <h3 className="text-xl text-center font-bold mb-4 text-gray-900">Pago</h3>
      </div>

      <div className="space-y-4">
        <div className="bg-[#F5F7FA] flex justify-between items-center p-3 rounded-xl">
          <p className="text-[#A7A7A7] font-bold text-xl">Total a pagar</p>
          <p className="text-2xl">{ formatAmount(form.amount_local, 'Bs. ') }</p>
        </div>

        <div>
          <p className="mb-1 text-text">Banco</p>
          <Select
            items={selects.banks}
            value={form.bank_id}
            onValueChange={v => onChange('bank_id', v)}
          />
        </div>

        <Input
          label="Número de referencia"
          value={form.reference}
          onValueChange={v => onChange('reference', v)}
        />
      </div>

      <div className="flex justify-center items-center gap-6 mt-8">
        <button
          className="text-[#A3A3A3] font-bold"
          onClick={onClose}
          disabled={isLoading}
        >
          Cerrar
        </button>

        <button
          className="bg-red text-white font-bold px-8 py-1 rounded-full"
          onClick={onSubmit}
        >
          Guardar
        </button>
      </div>
    </div>
  )
}

const useForm = (destiny, data, onClose, onSuccess) => {
  const initialForm = {
    destiny,
    user_id: data.at(0).user_id,
    amount: 0,
    amount_local: 0,
    bank_id: '',
    reference: '',
    items: data.map(x => x.id),
  };

  const [canFetch, setCanFetch] = useState(true);
  const [form, setForm] = useState(initialForm);
  const [selects, setSelects] = useState({ banks: [] });

  const getSelects = async () => {
    try {
      const banks = await GeneralService.getBanks();
      setSelects({ banks: banks.map(x => ({ value: x.id, label: x.name })) });

    } catch (error) {
      console.log(error);
    }
  }

  const onChange = (target, value) => {
    setForm(s => ({ ...s, page: 1, [target]: value }));
  }

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    if (form.isFilteringToPay)
      return onError('Debe seleccionar un propietario y rango de fecha para pagar');

    const filtered = data.filter(x => x.status === Constants.BILLING.STATUS.PENDING);
    if (!filtered.length)
      return onError('No hay registros pendientes para pagar');

    if (filtered.some(x => x.user_id !== filtered.at(0).user_id).length)
      return onError('Los datos deben ser de un mismo propietario');

    if (!form.bank_id)
      return onError('Debe seleccionar el banco');

    if (!form.reference)
      return onError('Debe indicar la referencia');

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;
    setCanFetch(false);

    try {
      await BillingService.admin.pay(form);
      toast.success('Pago realizado con éxito');
      onClose();
      onSuccess();

    } catch (error) {
      console.log(error);
    }
    setCanFetch(true);
  }

  useEffect(() => {
    getSelects();

    let amount = 0;
    let amount_local = 0;

    data.forEach((i) => {
      if (i.status === Constants.BILLING.STATUS.PAID) return;
      amount += Number(i.amount);
      amount_local += Number(i.amount_local);
    });
    setForm(s => ({ ...s, amount, amount_local }));
  }, []);

  return {
    data,
    form,
    isLoading: !canFetch,
    onChange,
    onSubmit,
    selects,
  }
}

export default ModalPay;
